<template>
  <div class='page page__list'>
    <search-bar
      @search="onSearch"
      name="pr_code,pr_detail,ip_vendname,ip_code"
      placeholder="输入物料、供应商、单号进行查找"
      ref="searchBar"
    />
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <router-link
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.ip_id"
        :to="'/purchase/sample_inquiry_price/'+item.ip_id"
      >
        <div class="weui-cell__bd">
          <p>{{item.ip_vendname}}</p>
          <p class="list-item-muted">{{item.createTime}}</p>
        </div>
        <div class="weui-cell__ft">
          <p>{{item.ip_code}}</p>
          <span
            class="list-item-status"
            :class="{'warning':item.ip_status!='已审核'}"
          >{{item.ip_status}}</span>
        </div>
      </router-link>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{items.length}}单</label>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import list from "@/mixins/list.js";

export default {
  mixins: [list],
  components: {
    SearchBar,
    FilterBar,
    ScrollList
  },
  data() {
    return {
      listUrl: "/api/sample/inquiryprice/list",
      params: {
        mode: "DETAIL",
        number: 1,
        size: 10,
      },
      filters: [
        {
          type: "date",
          name: "ip_auditdate"
        },
        {
          type: "condition",
          label: "状态",
          value: -1,
          options: [
            {
              value: -1,
              label: "全部"
            },
            {
              value: 1,
              label: "待审核",
              // condition: "ip_statuscode <> \'AUDITED\'"
              condition: "ip_statuscode <> 'AUDITED'"
            },
            {
              value: 2,
              label: "已审核",
              // condition: "ip_statuscode = \'AUDITED\'"
              condition: "ip_statuscode = 'AUDITED'"
            },
          ]
        }
      ]
    }
  }
}
</script>